import * as React from 'react'
import { createContext, useEffect, useState, useContext } from 'react'

type IColorModeContext = [string, (value?: string) => void]

const defaultState: IColorModeContext = ['default', () => undefined]

export const ColorModeContext = createContext(defaultState)
export const useColorMode = () => useContext(ColorModeContext)

const supportsDarkMode = () =>
  window.matchMedia('(prefers-color-scheme: dark)').matches

export const ColorModeProvider = ({ children }) => {
  const [colorMode, setColorMode] = useState(null)

  const setColorModePersistent = (value: string) => {
    setColorMode(value)
    window.localStorage.setItem('theme-color-mode', value)
  }

  useEffect(() => {
    const themeFromLocalStorage = window.localStorage.getItem(
      'theme-color-mode'
    )

    if (typeof themeFromLocalStorage === 'string') {
      setColorMode(themeFromLocalStorage)
    } else if (supportsDarkMode()) {
      setColorMode('dark')
    }
  }, [])

  return (
    <ColorModeContext.Provider value={[colorMode, setColorModePersistent]}>
      {children}
    </ColorModeContext.Provider>
  )
}
